module.exports = __webpack_public_path__ + "static/media/pokoj.f7c62661.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pokoje/pokoj.jpg
// module id = 95
// module chunks = 0